import React, { useState, useEffect, useRef, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { AppDispatch, RootState } from 'store';
import SocketContext from 'socket-context';
import { validateAndCreateSocketIfExist } from 'utils/SocketValidator';
import { pollActivityModalType, pollSubtype } from '../../types/Constants';
import RadioButton from 'components/buttons/RadioButton';
import MultipleCheckbox from 'components/buttons/MultipleCheckbox';
import { UserInfoMapperSocketHandler } from 'utils/UserInfoMapper';
import { parseToJson } from 'utils/StreamingHelperFunctions';
import { updateLiveStreamSettings } from 'store/reducers/livestreamSettings';
import { is } from 'date-fns/locale';
import { User } from 'models/User';
import { ReactComponent as PollLaunchBanner } from '../../../src/assets/images/poll-launch-banner.svg.svg';
import VotingClosedBanner from '../../../src/assets/images/pollActivity.png';
import axiosInstance from 'config/axios';
import AllAudioConsumers from 'components/classroom/components/backup/AllAudioConsumers';
import RoomClient from 'components/containers/utils/mediaSoup/RoomClient';

interface PollActivityProps {
  session_id?: string;
  resSettings?: any;
  roomClient?: RoomClient | null;
}

const PollActivity: React.FC<PollActivityProps> = ({ roomClient, session_id, resSettings }) => {
  const { session_id: paramSessionId } = useParams<{ session_id: string }>();
  const finalSessionId = session_id || paramSessionId;

  const socketList = useContext(SocketContext);
  const profileData = useSelector((state: RootState) => state.auth.user as User);
  const batchData = useSelector((state: RootState) => state.live.settings?.batch);
  console.log('batchData', batchData);

  const [modalType, setModalType] = useState(pollActivityModalType.POLL_LAUNCHED);
  const [questions, setQuestions] = useState<any[]>([]);
  const [answers, setAnswers] = useState<any[][]>([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  // const [pollData, setPollData] = useState<any>(null);
  const [pollActivityData, setPollActivityData] = useState<any>(null);
  const [time, setTime] = useState(0);
  const timeRef = useRef<number>(0);
  const [responseData, setResponseData] = useState<any[]>([]);
  const [isSubmited, setIsSubmited] = useState(false);
  let userInfoHandler = new UserInfoMapperSocketHandler();
  const [qusScreenModal, setQusScreenModal] = useState(false);
  const [updateTime, setUpdateTime] = useState<any>();
  const [activityPollData, setActivityPollData] = useState<any>(null);
  const [userPollData, setUserPollData] = useState<any[]>([]);
  const dispatch: AppDispatch = useDispatch();
  const user: any = useSelector((state: RootState) => state.auth.user as User);
  const roomId = useSelector((state: RootState) => state.live.settings.roomId);
  const consumers = useSelector(
    (state: RootState) => state.live.settings.consumers
  );

  const data: any = parseToJson(activityPollData?.poll_activity_data);
  const poll_activity_data: any = parseToJson(data?.activity_data);
  console.log('poll_activity_data', poll_activity_data);

  const prevDetails = useRef<any>();
  const [detailes, setDetailes] = useState<any>({});
  const audioRef = useRef<HTMLAudioElement>(null);
  const [micOn, setMicOn] = useState(false);

  const startTimer = () => {
    let intervalTimer = setInterval(() => {
      if (timeRef?.current <= 0 || detailes !== prevDetails.current) {
        clearInterval(intervalTimer);
        return;
      }
      setTime((_time) => (_time - 1));
    }, 1000);
  };

  useEffect(() => {
    roomClient?.consumerResumeAllAudio();
  }, [])

  useEffect(() => {
    prevDetails.current = detailes;
    startTimer();
  }, [detailes]);

  // useEffect(() => {
  //   const videoConsumer: any = Object.values(consumers).find(
  //     (consumer: any) =>
  //       consumer.peerId === "trainer@vtt" && consumer.kind === "video"
  //   );
  //   const audioConsumer: any = Object.values(consumers).find(
  //     (consumer: any) =>
  //       consumer.peerId === "trainer@vtt" && consumer.kind === "audio"
  //   );
  //   // Audio handling
  //   if (
  //     audioConsumer &&
  //     audioConsumer.track &&
  //     audioConsumer.track.readyState === "live" &&
  //     !audioConsumer.locallyPaused &&
  //     !audioConsumer.remotelyPaused
  //   ) {
  //     setTimeout(() => {
  //       if (audioRef.current) {
  //         const stream = new MediaStream([audioConsumer.track]);
  //         audioRef.current.srcObject = stream;
  //         audioRef.current
  //           .play().then(() => console.log('Video play success'))
  //           .catch(err => {
  //             console.error('Video play error:', err);
  //             if (err.name === 'AbortError') {
  //               console.log('Ignoring AbortError on play');
  //             }
  //           });;
  //       }
  //     }, 100);
  //     setMicOn(true);
  //   } else {
  //     setMicOn(false);
  //   }
  // }, [consumers]);


  useEffect(() => {
    timeRef.current = time;
    const interval = setInterval(() => {
      if (timeRef.current > 0) setTime((prev) => prev - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, [time]);

  useEffect(() => {
    userInfoHandler = validateAndCreateSocketIfExist(session_id, handleMessage, socketList);
  }, []);

  useEffect(() => {
    if (resSettings) {
      if (resSettings.type === 'broadcast_poll' && resSettings.sub_type === 'dot_show_question_screen_score') {
        setQusScreenModal(true);
      } else if (resSettings.type === 'broadcast_poll' && resSettings.sub_type === 'show_question_screen_score') {
        setQusScreenModal(false);
      } else if (resSettings.type === 'broadcast_poll' && resSettings.sub_type === 'show_initial_screen') {
        setActivityPollData(resSettings)
        setIsSubmited(true)
        setCurrentIndex(0)
        setModalType(pollActivityModalType?.POLL_LAUNCHED)
      }
    }
  }, [resSettings]);

  useEffect(() => {
    if (updateTime !== undefined && updateTime !== null) {
      setTime((_time) => _time + +updateTime)
    }
  }, [updateTime]);

  useEffect(() => {
    console.log("userPollData2", userPollData);
    if (
      userPollData?.length > 0 &&
      pollActivityData?.poll_description &&
      Array.isArray(pollActivityData.poll_description) &&
      pollActivityData.poll_description.length > 0
    ) {
      calculatePollScore(pollActivityData.poll_description, userPollData);
    }
  }, [userPollData, pollActivityData?.poll_description]);


  const calculatePollScore = (questionSet: any[] | undefined, responseSets: any[]) => {
    console.log("questionSet", questionSet);
    console.log("responseSets", responseSets);

    if (!questionSet || !Array.isArray(questionSet) || questionSet.length === 0) {
      console.log("calculatePollScore: Invalid or empty questionSet, skipping calculation");
      return [];
    }

    questionSet.forEach((question) => {
      if (question?.answer_data?.[0]?.answerMap) {
        question.answer_data[0].answerMap.forEach((map: any) => {
          map.score = 0;
          map.respondents = [];
        });
      }
    });

    const respondedCounts = new Array(questionSet.length).fill(0);
    const uniqueRespondents = new Set<string>();

    responseSets.forEach((responseSet: any) => {
      if (responseSet?.trainee_responses && responseSet?.trainee_email) {
        responseSet.trainee_responses.forEach((response: any, resIndex: number) => {
          if (response?.length > 0 && !uniqueRespondents.has(`${responseSet.trainee_email}-${resIndex}`)) {
            respondedCounts[resIndex]++;
            uniqueRespondents.add(`${responseSet.trainee_email}-${resIndex}`);
          }
        });
      }
    });

    responseSets.forEach((responseSet: any) => {
      if (responseSet?.trainee_responses && responseSet?.trainee_email) {
        responseSet.trainee_responses.forEach((response: any, resIndex: number) => {
          response?.forEach((eachRep: any) => {
            questionSet.forEach((question: any, questionIndex: number) => {
              if (resIndex === questionIndex && question?.answer_data?.[0]?.answer) {
                question.answer_data[0].answer.forEach((ansVal: any, ansValIndex: number) => {
                  if (ansValIndex === eachRep && question.answer_data[0].answerMap?.[ansValIndex]) {
                    // Only increment score if this is the first response from this trainee for this question
                    if (!question.answer_data[0].answerMap[ansValIndex].respondents?.some(
                      (r: any) => r.email === responseSet.trainee_email
                    )) {
                      question.answer_data[0].answerMap[ansValIndex].score += 1;

                      if (!question.answer_data[0].answerMap[ansValIndex].respondents) {
                        question.answer_data[0].answerMap[ansValIndex].respondents = [];
                      }

                      const isCurrentUser = responseSet.trainee_email === user.email;
                      const respondentEmail = responseSet.trainee_email;
                      const respondentName = isCurrentUser
                        ? user.name || "You"
                        : responseSet.trainee_name || "Anonymous";

                      const respondent = {
                        name: respondentName,
                        email: respondentEmail,
                        isYou: isCurrentUser,
                      };

                      question.answer_data[0].answerMap[ansValIndex].respondents.push(respondent);
                    }
                  }
                });
              }
            });
          });
        });
      }
    });

    questionSet.forEach((question: any, qIndex: number) => {
      if (question?.answer_data?.[0]?.answerMap) {
        question.answer_data[0].answerMap.forEach((map: any) => {
          map.total = respondedCounts[qIndex];
        });
      }
    });

    setResponseData(questionSet);
    return questionSet;
  };

  useEffect(() => {
    if (pollActivityData && Object.keys(pollActivityData).length > 0) {
      if (pollActivityData.type === 'quick_launch') {
        if (pollActivityData?.activity_data?.poll_description) {
          if (!pollActivityData?.activity_data?.poll_description[0].answer_data[0].answerMap) {
            const questionSet = pollActivityData?.activity_data?.poll_description;
            questionSet.forEach((item) => {
              if (!item.answer_data[0]['answerMap']) {
                const list: { ans: string; score: number; total: number }[] = [];
                item.answer_data[0]['answer'].forEach((ansr) => {
                  list.push({
                    ans: ansr,
                    score: 0,
                    total: 0,
                  });
                });
                item.answer_data[0]['answerMap'] = list;
              }
            });
            setPollActivityData((prev) => ({ ...prev, poll_description: questionSet }));
          }
        }
      } else if (pollActivityData?.poll_description) {
        if (!pollActivityData?.poll_description[0].answer_data[0].answerMap) {
          const questionSet = pollActivityData?.poll_description;
          questionSet.forEach((item) => {
            if (!item.answer_data[0]['answerMap']) {
              const list: { ans: string; score: number; total: number }[] = [];
              item.answer_data[0]['answer'].forEach((ansr) => {
                list.push({
                  ans: ansr,
                  score: 0,
                  total: 0,
                });
              });
              item.answer_data[0]['answerMap'] = list;
            }
          });
          setPollActivityData((prev) => ({ ...prev, poll_description: questionSet }));
        }
      }
    }
  }, [pollActivityData]);


  const handleMessage = (data: any) => {
    const msg = JSON.parse(data);
    if (msg.type === 'broadcast_poll') {
      if (msg.sub_type === 'get_trainee_responses') {
        // Prevent duplicate responses by checking trainee_email
        setUserPollData((prev) => {
          // Remove any existing response from the same trainee_email
          const filteredPrev = prev.filter(
            (response) => response.trainee_email !== msg.user_poll_data.trainee_email
          );
          // Append the new response
          return [...filteredPrev, msg.user_poll_data];
        });
        console.log('userPollData', msg?.user_poll_data);
        return;
      }
      if (msg.sub_type === 'broadcast_poll_time_extended') {
        setUpdateTime(msg.timeExtended);
        return;
      }
      if (msg?.sub_type === pollSubtype?.DOT_SHOW_QUESTION_SCREEN_SCORE) {
        setQusScreenModal(true);
        return;
      }
      if (msg?.sub_type === 'completely_close_the_poll') {
        setModalType(pollActivityModalType?.VOTING_CLOSED);
        setTime(0);
        return;
      }
    }

    if (msg?.sub_type === pollSubtype?.SHOW_INITIAL_SCREEN) {
      setActivityPollData(msg);
      setIsSubmited(true);
      setCurrentIndex(0);
      setModalType(pollActivityModalType?.POLL_LAUNCHED);
      return;
    }
    if (msg?.sub_type === pollSubtype?.CLOSE_VOTING_BROADCAST) {
      setModalType(pollActivityModalType?.VOTING_CLOSED);
      if (!isSubmited) {
        submitResponse();
      }
      return;
    }

    if (msg?.sub_type === pollSubtype?.SHOW_QUESTION_SCREENS) {
      if (msg?.poll_activity_data) {
        let _data = JSON.parse(msg?.poll_activity_data);
        if (_data?.session_map_id) {
          let activity_data = JSON.parse(data?.poll_activity_data);
          setTime(activity_data.activity_data?.voting_window_timer);
          setDetailes(activity_data);
          setPollActivityData(activity_data.activity_data);
          if (activity_data?.poll_description) {
            setQuestions(activity_data?.poll_description);
          } else {
            setQuestions(activity_data?.activity_data?.poll_description);
          }
          setAnswers(Array.from(Array(activity_data?.poll_description?.length).fill([])));
        } else {
          let activity_data = JSON.parse(_data?.activity_data);
          setTime(activity_data?.voting_window_timer);
          setDetailes(activity_data);
          setPollActivityData(activity_data);
          if (activity_data?.poll_description) {
            setQuestions(activity_data?.poll_description);
          } else {
            setQuestions(activity_data?.activity_data?.poll_description);
          }
          setAnswers(Array.from(Array(activity_data?.poll_description?.length).fill([])));
        }
        setModalType(pollActivityModalType?.SHOW_QUESTION_SCREENS);
      }
      return;
    }
  };

  const handleAnswerChange = (value: any) => {
    const updated = [...answers];
    updated[currentIndex] = value;
    setAnswers(updated);
  };

  const submitResponse = () => {
    userInfoHandler = validateAndCreateSocketIfExist(session_id, handleMessage, socketList);
    setTimeout(() => {
      const answerIndices = answers.map((answer, questionIndex) => {
        const question = questions[questionIndex];
        if (!question || !question.answer_data[0].answer) return [];
        return answer.map((selectedValue: string) => {
          const index = question.answer_data[0].answer.findIndex((ans: string) => ans === selectedValue);
          return index !== -1 ? index : null;
        }).filter((index: number | null) => index !== null);
      });
      const payload = {
        type: 'broadcast_poll',
        sub_type: 'get_trainee_responses',
        room_id: finalSessionId,
        user_poll_data: {
          trainee_responses: answerIndices,
          trainee_email: profileData?.email,
          trainee_name: profileData?.name,
        },
        timestamp: new Date(),
      };
      console.log('Sending response payload:', JSON.stringify(payload, null, 2));
      userInfoHandler.sendMessage(JSON.stringify(payload));
      saveActions();
      setTimeout(() => {
        if (isSubmited) {
          if (qusScreenModal) {
            setModalType(pollActivityModalType.WAITING_OTHERS);
          } else {
            setModalType(pollActivityModalType.SHOW_RESPONSE);
            setCurrentIndex(0);
          }
        } else {
          setModalType(pollActivityModalType?.VOTING_CLOSED);
          setIsSubmited(prevIsSubmited => !prevIsSubmited);
          setTime(0)
        }

      }, 1200);
    }, 1000);

  };
  const saveActions = async () => {
    const session = await axiosInstance.post("/trainee/live_session_plan_preview_trainee", {
      session_map_id: roomId
    });

    const responseData = session?.data?.responseData || {};
    const allActivities = [
      ...(responseData.prePlannedActivities || []),
      ...(responseData.quickSetupActivities || [])
    ];

    const launchData = allActivities.find((el: any) => el.status === "LAUNCH");
    if (!launchData?.id) {
      return;
    }

    const engagementType = "L_RESPONSE"
    const obj = {
      engagementType,
      userId: user?.id,
      sessionActivityExecutionLogId: launchData?.id,
      isRead: "NO",
      participantId: user?.id,
      subType: null
    }

    await axiosInstance.post("/session/save_session_actions_log", obj);
  }

  const renderQuestionUI = () => {
    const item = questions[currentIndex];
    if (!item) return null;

    const options = item.answer_data[0].answer.map((x: string, i: number) => ({
      id: i + 1,
      value: x
    }));

    return item.answer_data[0].allow_multiple_choice ? (
      <MultipleCheckbox
        data={options}
        selected={answers[currentIndex] || []}
        onCheck={(values) => handleAnswerChange(values)}
      />
    ) : (
      <RadioButton
        data={options}
        selected={answers[currentIndex]?.[0] || ""}
        onSelect={(value) => handleAnswerChange([value])}
      />
    );
  };

  return (
    <div className="flex flex-col w-full h-full items-center text-white px-4 mobile:px-2 tablet:px-4 laptop:px-6 py-6">
      <h1 className="text-xl tablet:text-2xl laptop:text-3xl font-bold mb-2 text-center break-words">
        {poll_activity_data?.title || detailes?.activity_name || detailes?.title}
      </h1>

      {time > 0 && (
        <p className="mb-4 text-red-400 text-sm tablet:text-base text-center">
          Voting closes in {time} seconds
        </p>
      )}

      {/* Show this SVG before poll starts */}
      {/* 1. Poll Launch Banner */}
      {modalType === pollActivityModalType.POLL_LAUNCHED && (
        <div className="w-full flex justify-center mb-6 mobile:mb-4">
          <div className="relative w-full max-w-[536px] mobile:max-w-[90%] h-[120px] mobile:h-[100px] tablet:h-[140px] laptop:h-[160px] desktop:h-[180px] bg-gray-800 rounded-2xl flex items-center justify-center gap-4 mobile:gap-2 tablet:gap-4 laptop:gap-6 text-app-yellow font-bold text-lg mobile:text-sm tablet:text-lg laptop:text-xl desktop:text-2xl shadow-lg">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              viewBox="0 0 57 57"
              fill="none"
              className="mobile:w-[30px] mobile:h-[30px] tablet:w-[40px] tablet:h-[40px] laptop:w-[50px] laptop:h-[50px] desktop:w-[57px] desktop:h-[57px]"
            >
              <path
                d="M21.375 25.5611V30.7384C21.375 31.985 22.1902 33 23.1926 33H34.3163C35.3187 33 36.1339 31.985 36.1339 30.7384V25.5611C36.1339 22.8721 34.5684 20.6306 32.5119 20.1711C33.1059 19.1908 33.4585 17.9726 33.4585 16.6533C33.4585 13.4259 31.3482 10.8 28.7545 10.8C26.1607 10.8 24.0504 13.4259 24.0504 16.6533C24.0504 17.9726 24.403 19.1908 24.997 20.1711C22.9405 20.6306 21.375 22.8715 21.375 25.5611ZM28.7545 13.2239C30.2743 13.2239 31.5105 14.7628 31.5105 16.6533C31.5105 18.5445 30.2743 20.0827 28.7545 20.0827C27.2346 20.0827 25.9984 18.5445 25.9984 16.6533C25.9984 14.7628 27.2346 13.2239 28.7545 13.2239ZM23.323 25.5611C23.323 23.877 24.4243 22.5073 25.7772 22.5073H31.7317C33.0851 22.5073 34.186 23.877 34.186 25.5611V30.5755H32.6636V27.6283C32.6636 26.9586 32.2273 26.4164 31.6896 26.4164C31.1514 26.4164 30.7156 26.9586 30.7156 27.6283V30.5755H26.7933V27.6283C26.7933 26.9586 26.3575 26.4164 25.8193 26.4164C25.2811 26.4164 24.8453 26.9586 24.8453 27.6283V30.5755H23.323V25.5611Z"
                fill="white"
              />
              <path
                d="M0.966409 57H56.0331C56.5671 57 57 56.4709 57 55.8187C57 55.1659 56.5671 54.6374 56.0331 54.6374H55.9123V39.9797C55.9123 39.3275 55.4799 38.7984 54.9459 38.7984C54.4123 38.7984 53.9795 39.3275 53.9795 39.9797V54.6374H43.4255V19.8086H53.9795V34.4664C53.9795 35.1192 54.4123 35.6483 54.9459 35.6483C55.4799 35.6483 55.9123 35.1192 55.9123 34.4664V19.6505C55.9123 18.4348 55.1034 17.4461 54.1088 17.4461H43.2961C42.3015 17.4461 41.4927 18.4348 41.4927 19.6505V54.6374H35.6117V36.8985C35.6117 35.6828 34.8028 34.694 33.8087 34.694H30.755C30.2214 34.694 29.7885 35.2232 29.7885 35.8753C29.7885 36.5281 30.2214 37.0566 30.755 37.0566H33.6788V54.6374H23.1254V37.0566H26.245C26.7786 37.0566 27.2115 36.5281 27.2115 35.8753C27.2115 35.2232 26.7786 34.694 26.245 34.694H22.9955C22.0014 34.694 21.192 35.6828 21.192 36.8985V54.6374H15.3115V2.20445C15.3115 0.98871 14.5022 0 13.5081 0H2.69487C1.70028 0 0.891412 0.98871 0.891412 2.20445V54.6417C0.392604 54.6885 0 55.1973 0 55.8187C0 56.4709 0.432367 57 0.966409 57ZM2.82423 2.36257H13.3782V54.6374H2.82423V2.36257Z"
                fill="white"
              />
            </svg>
            Poll launched Vote NOW!
          </div>
        </div>
      )}

      {/* 2. Question Screens */}
      {modalType === pollActivityModalType.SHOW_QUESTION_SCREENS && (
        <div className="bg-white text-black rounded-xl p-3 mobile:p-4 tablet:p-6 laptop:p-8 desktop:p-10 largescreen:p-12 xxl:p-14 w-full max-w-[95%] mobile:max-w-[90%] tablet:max-w-[600px] laptop:max-w-[800px] desktop:max-w-[900px] largescreen:max-w-[1000px] xxl:max-w-[1100px] shadow-2xl mx-auto">
          <div className="flex flex-wrap justify-start mb-3 mobile:mb-4 tablet:mb-5 laptop:mb-6 gap-1 mobile:gap-2 tablet:gap-3 laptop:gap-4">
            {questions.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setCurrentIndex(idx)}
                className={`px-3 py-1 rounded-full text-sm shadow-2xl transition ${idx === currentIndex ? "bg-purple-800 text-white" : "text-white bg-gray-800"
                  }`}
              >
                Question {idx + 1}
              </button>
            ))}
          </div>

          <h2 className="text-base tablet:text-lg text-purple-900 font-bold mb-4 shadow-sm px-2 py-1 rounded-md text-left">
            {questions[currentIndex]?.question}
          </h2>

          {renderQuestionUI()}

          <div className="flex justify-start">
            <button
              className={`mt-6 px-4 py-2 rounded-full text-white shadow-xl transition ${answers[currentIndex]?.length ? "bg-purple-900" : "bg-gray-200 cursor-not-allowed"
                }`}
              disabled={!answers[currentIndex]?.length}
              onClick={() => {
                if (currentIndex === questions.length - 1) {
                  submitResponse(); // This should set modalType to WAITING_OTHERS
                } else {
                  setCurrentIndex((prev) => prev + 1);
                }
              }}
            >
              {currentIndex === questions.length - 1 ? "Submit" : "Next"}
            </button>
          </div>
        </div>
      )}

      {/* 3. Waiting for Others */}
      {/* {modalType === pollActivityModalType.WAITING_OTHERS && (
                <div className="w-full flex justify-center mb-6 mobile:mb-4">
          <div className="relative w-full max-w-[536px] mobile:max-w-[90%] h-[120px] mobile:h-[100px] tablet:h-[140px] laptop:h-[160px] desktop:h-[180px] bg-gray-800 rounded-2xl flex items-center justify-center text-app-yellow font-bold text-lg mobile:text-sm tablet:text-lg laptop:text-xl desktop:text-2xl shadow-lg">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              viewBox="0 0 57 57"
              fill="none"
              className="mobile:w-[30px] mobile:h-[30px] tablet:w-[40px] tablet:h-[40px] laptop:w-[50px] laptop:h-[50px] desktop:w-[57px] desktop:h-[57px]"
            >
              <path
                d="M21.375 25.5611V30.7384C21.375 31.985 22.1902 33 23.1926 33H34.3163C35.3187 33 36.1339 31.985 36.1339 30.7384V25.5611C36.1339 22.8721 34.5684 20.6306 32.5119 20.1711C33.1059 19.1908 33.4585 17.9726 33.4585 16.6533C33.4585 13.4259 31.3482 10.8 28.7545 10.8C26.1607 10.8 24.0504 13.4259 24.0504 16.6533C24.0504 17.9726 24.403 19.1908 24.997 20.1711C22.9405 20.6306 21.375 22.8715 21.375 25.5611ZM28.7545 13.2239C30.2743 13.2239 31.5105 14.7628 31.5105 16.6533C31.5105 18.5445 30.2743 20.0827 28.7545 20.0827C27.2346 20.0827 25.9984 18.5445 25.9984 16.6533C25.9984 14.7628 27.2346 13.2239 28.7545 13.2239ZM23.323 25.5611C23.323 23.877 24.4243 22.5073 25.7772 22.5073H31.7317C33.0851 22.5073 34.186 23.877 34.186 25.5611V30.5755H32.6636V27.6283C32.6636 26.9586 32.2273 26.4164 31.6896 26.4164C31.1514 26.4164 30.7156 26.9586 30.7156 27.6283V30.5755H26.7933V27.6283C26.7933 26.9586 26.3575 26.4164 25.8193 26.4164C25.2811 26.4164 24.8453 26.9586 24.8453 27.6283V30.5755H23.323V25.5611Z"
                fill="white"
              />
              <path
                d="M0.966409 57H56.0331C56.5671 57 57 56.4709 57 55.8187C57 55.1659 56.5671 54.6374 56.0331 54.6374H55.9123V39.9797C55.9123 39.3275 55.4799 38.7984 54.9459 38.7984C54.4123 38.7984 53.9795 39.3275 53.9795 39.9797V54.6374H43.4255V19.8086H53.9795V34.4664C53.9795 35.1192 54.4123 35.6483 54.9459 35.6483C55.4799 35.6483 55.9123 35.1192 55.9123 34.4664V19.6505C55.9123 18.4348 55.1034 17.4461 54.1088 17.4461H43.2961C42.3015 17.4461 41.4927 18.4348 41.4927 19.6505V54.6374H35.6117V36.8985C35.6117 35.6828 34.8028 34.694 33.8087 34.694H30.755C30.2214 34.694 29.7885 35.2232 29.7885 35.8753C29.7885 36.5281 30.2214 37.0566 30.755 37.0566H33.6788V54.6374H23.1254V37.0566H26.245C26.7786 37.0566 27.2115 36.5281 27.2115 35.8753C27.2115 35.2232 26.7786 34.694 26.245 34.694H22.9955C22.0014 34.694 21.192 35.6828 21.192 36.8985V54.6374H15.3115V2.20445C15.3115 0.98871 14.5022 0 13.5081 0H2.69487C1.70028 0 0.891412 0.98871 0.891412 2.20445V54.6417C0.392604 54.6885 0 55.1973 0 55.8187C0 56.4709 0.432367 57 0.966409 57ZM2.82423 2.36257H13.3782V54.6374H2.82423V2.36257Z"
                fill="white"
              />
            </svg>
            You have voted!Others voting now ...
          </div>
        </div>
      )} */}

      {/* 4. Voting Closed Message */}
      {modalType === pollActivityModalType.VOTING_CLOSED && (
        <div className="w-full flex justify-center mb-6 mobile:mb-4">
          <div className="relative w-full max-w-[536px] mobile:max-w-[90%] h-[120px] mobile:h-[100px] tablet:h-[140px] laptop:h-[160px] desktop:h-[180px] bg-gray-800 rounded-2xl flex items-center justify-center text-app-yellow font-bold text-lg gap-4 mobile:gap-2 mobile:text-sm tablet:text-lg laptop:text-xl desktop:text-2xl shadow-lg">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              viewBox="0 0 57 57"
              fill="none"
              className="mobile:w-[30px] mobile:h-[30px] tablet:w-[40px] tablet:h-[40px] laptop:w-[50px] laptop:h-[50px] desktop:w-[57px] desktop:h-[57px]"
            >
              <path
                d="M21.375 25.5611V30.7384C21.375 31.985 22.1902 33 23.1926 33H34.3163C35.3187 33 36.1339 31.985 36.1339 30.7384V25.5611C36.1339 22.8721 34.5684 20.6306 32.5119 20.1711C33.1059 19.1908 33.4585 17.9726 33.4585 16.6533C33.4585 13.4259 31.3482 10.8 28.7545 10.8C26.1607 10.8 24.0504 13.4259 24.0504 16.6533C24.0504 17.9726 24.403 19.1908 24.997 20.1711C22.9405 20.6306 21.375 22.8715 21.375 25.5611ZM28.7545 13.2239C30.2743 13.2239 31.5105 14.7628 31.5105 16.6533C31.5105 18.5445 30.2743 20.0827 28.7545 20.0827C27.2346 20.0827 25.9984 18.5445 25.9984 16.6533C25.9984 14.7628 27.2346 13.2239 28.7545 13.2239ZM23.323 25.5611C23.323 23.877 24.4243 22.5073 25.7772 22.5073H31.7317C33.0851 22.5073 34.186 23.877 34.186 25.5611V30.5755H32.6636V27.6283C32.6636 26.9586 32.2273 26.4164 31.6896 26.4164C31.1514 26.4164 30.7156 26.9586 30.7156 27.6283V30.5755H26.7933V27.6283C26.7933 26.9586 26.3575 26.4164 25.8193 26.4164C25.2811 26.4164 24.8453 26.9586 24.8453 27.6283V30.5755H23.323V25.5611Z"
                fill="white"
              />
              <path
                d="M0.966409 57H56.0331C56.5671 57 57 56.4709 57 55.8187C57 55.1659 56.5671 54.6374 56.0331 54.6374H55.9123V39.9797C55.9123 39.3275 55.4799 38.7984 54.9459 38.7984C54.4123 38.7984 53.9795 39.3275 53.9795 39.9797V54.6374H43.4255V19.8086H53.9795V34.4664C53.9795 35.1192 54.4123 35.6483 54.9459 35.6483C55.4799 35.6483 55.9123 35.1192 55.9123 34.4664V19.6505C55.9123 18.4348 55.1034 17.4461 54.1088 17.4461H43.2961C42.3015 17.4461 41.4927 18.4348 41.4927 19.6505V54.6374H35.6117V36.8985C35.6117 35.6828 34.8028 34.694 33.8087 34.694H30.755C30.2214 34.694 29.7885 35.2232 29.7885 35.8753C29.7885 36.5281 30.2214 37.0566 30.755 37.0566H33.6788V54.6374H23.1254V37.0566H26.245C26.7786 37.0566 27.2115 36.5281 27.2115 35.8753C27.2115 35.2232 26.7786 34.694 26.245 34.694H22.9955C22.0014 34.694 21.192 35.6828 21.192 36.8985V54.6374H15.3115V2.20445C15.3115 0.98871 14.5022 0 13.5081 0H2.69487C1.70028 0 0.891412 0.98871 0.891412 2.20445V54.6417C0.392604 54.6885 0 55.1973 0 55.8187C0 56.4709 0.432367 57 0.966409 57ZM2.82423 2.36257H13.3782V54.6374H2.82423V2.36257Z"
                fill="white"
              />
            </svg>
            Live Poll has ended!
          </div>
        </div>
      )}

      {/* 5. Poll Results */}
      {modalType === pollActivityModalType.SHOW_RESPONSE && (
        <div className="bg-white text-black rounded-xl p-3 mobile:p-4 tablet:p-6 laptop:p-8 desktop:p-10 largescreen:p-12 xxl:p-14 w-full max-w-[95%] mobile:max-w-[90%] tablet:max-w-[600px] laptop:max-w-[800px] desktop:max-w-[900px] largescreen:max-w-[1000px] xxl:max-w-[1100px] shadow-2xl mx-auto">
          <h2 className="text-lg text-purple-900 font-bold mb-4 shadow-sm px-2 py-1 rounded-md">
            Poll Results
          </h2>

          <div className="flex flex-wrap justify-start mb-3 mobile:mb-4 tablet:mb-5 laptop:mb-6 gap-1 mobile:gap-2 tablet:gap-3 laptop:gap-4">
            {responseData.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setCurrentIndex(idx)}
                className={`px-3 py-1 rounded-full text-sm shadow-2xl transition ${idx === currentIndex ? "bg-purple-800 text-white" : "text-white bg-gray-800"}`}
              >
                Question {idx + 1}
              </button>
            ))}
          </div>

          <div className="mb-8">
            <p className="font-bold text-lg mb-4 text-purple-900">
              Question {currentIndex + 1}: {responseData[currentIndex]?.question}
            </p>

            <div className="flex flex-col gap-4">
              {responseData[currentIndex]?.answer_data[0]?.answerMap?.map((answer: any, i: number) => {
                const isUser = answer.respondents?.some((r: any) => r.isYou);
                const percentage = answer.total > 0 ? Math.round((answer.score / answer.total) * 100) : 0;
                return (
                  <div
                    key={i}
                    className="relative flex justify-between items-center px-6 py-4 rounded-2xl bg-white border border-gray-300 shadow-lg"
                  >
                    <div className="font-semibold text-base">{answer.ans}</div>
                    <div className="italic text-sm text-gray-700">{answer.score}/{answer.total}</div>
                    <div className="text-purple-900 font-bold text-lg">{percentage}%</div>
                    {isUser && (
                      <div className="absolute bottom-1 right-3 text-white text-xs px-2 bg-purple-800 rounded-full">
                        Your Response
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
      <AllAudioConsumers consumers={Object.values(consumers)} />

    </div>
  )
}
export default PollActivity;
